import { Image } from "@/components/ui/image/image";

export const FeatureOverview = () => {
	return (
		<div className="space-y-2">
			<h5 className="text-base font-bold">Google無料予約リンクとは</h5>
			<div className="space-y-6 p-4">
				<p className="text-sm">
					Google無料予約リンクは、Googleが宿泊施設向けに提供する
					<strong>無料の予約導線</strong>です。
					<br />
					Google検索やGoogleマップ、Googleトラベルなどに、自施設の予約リンクを無料で掲載できるため、国内外のゲストからの直接予約を促進できます。
				</p>

				<figure className="space-y-1.5">
					<Image
						src="/assets/google-free-booking-links/about.jpg"
						alt="Google無料予約リンクとは"
						className="rounded"
					/>
					<figcaption>「施設名」や「地域名 + ホテル」などでGoogle検索した際に表示されます</figcaption>
				</figure>
			</div>
		</div>
	);
};
